import { useEffect, useRef } from "react";
import { onHostMessage } from "./bridge";

/** В программе две страницы с одним входом — всплывашка (/tray) и окно
 *  (/tray/app), — и войти человек может в любой. Программа говорит другой
 *  странице `recheck-auth`, и та, если ещё не вошла (форма входа или «нет
 *  связи»), переспрашивает /me — не заставляя входить второй раз. Уже вошедшей
 *  страницей это не нужно: неудачный повтор размонтировал бы её посреди дела
 *  (TrayOffline). Выход приходит отдельным сообщением `logout`. */
export function useRecheckAuth(on: boolean, authed: boolean, retry: () => void) {
  const authedRef = useRef(authed);
  authedRef.current = authed;
  useEffect(() => {
    if (!on) return;
    return onHostMessage((m) => {
      if (m.type === "recheck-auth" && !authedRef.current) retry();
    });
  }, [on, retry]);
}
